<template>
    <div class="detail-toggle-container container">
        <div ref="continueReading" class="detail-description body-book" :class="{ cropped: cropped }">
            <slot></slot>
        </div>

        <div class="continue-button-container" :class="{ collapsed: cropped }" v-if="canBeCropped">
            <button @click.prevent="handleClick">
                <SvgsContinueReading v-show="cropped" />
                <SvgsReadLess v-show="!cropped" />
            </button>
        </div>
    </div>
</template>

<script setup>
    const continueReading = ref(null);
    const canBeCropped = ref(false);
    const cropped = ref(false);
    const height = ref('auto');

    function handleClick() {
        cropped.value = !cropped.value;
    }

    onMounted(() => {
        if (import.meta.client) {
            if (window.innerWidth > 768) {
                canBeCropped.value = false;
                cropped.value = false;
                return;
            }

            const realHeight = continueReading.value.offsetHeight;
            if (realHeight > 100) {
                canBeCropped.value = true;
                cropped.value = true;
            }
            height.value = realHeight;
        }
    });
</script>

<style lang="scss" scoped>
    .detail-toggle-container {
        margin-bottom: 30px;

        .detail-description {

            a { 
                color: $red;
                text-decoration: underline;

                &:hover {
                    color: $turquoise;
                }
            }            

            &.cropped {
                height: 95px;
                overflow: hidden;
            }
        }

        .continue-button-container {
            position: relative;
            display: flex;
            width: 100%;
            padding-top: 20px;

            &::before {
                content: '';
                position: absolute;
                display: block;
                top: -80px;
                left: 0;
                width: 100%;
                height: 80px;
                background: linear-gradient(0deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
                opacity: 0;
            }

            button {
                display: flex;

                svg {
                    display: flex;
                }
            }

            &.collapsed {
                &::before {
                    opacity: 1;
                }
            }
        }
    }
</style>
